var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14079_41292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.73225 9.71081C8.73586 9.42427 8.75937 9.21294 8.80276 9.07683C8.87147 8.86192 9.01068 8.67388 9.22041 8.51269L9.60552 8.21719C9.99605 7.91632 10.26 7.66918 10.3974 7.47576C10.6325 7.15697 10.75 6.76477 10.75 6.29913C10.75 5.53978 10.4788 4.96669 9.93639 4.57985C9.3976 4.19302 8.71959 3.9996 7.90237 3.9996C7.28041 3.9996 6.75608 4.13571 6.32939 4.40793C5.65319 4.83416 5.29339 5.55769 5.25 6.57851H6.81755C6.81755 6.28122 6.90434 5.99467 7.07791 5.71887C7.2551 5.44307 7.55342 5.30517 7.97288 5.30517C8.39957 5.30517 8.69247 5.418 8.85158 5.64365C9.0143 5.86573 9.09566 6.11287 9.09566 6.38509C9.09566 6.62149 9.02334 6.83819 8.8787 7.03519C8.79914 7.14981 8.69428 7.25548 8.5641 7.35218L8.16815 7.65843C7.77761 7.9593 7.53534 8.22615 7.44132 8.45897C7.3473 8.6882 7.28945 9.10549 7.26775 9.71081H8.73225Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22978 11.9996H8.84615V10.4469H7.22978V11.9996Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7.99986C16 3.58166 12.4183 0 8 0C3.58172 0 0 3.58166 0 7.99986C0 12.4181 3.58172 15.9997 8 15.9997C12.4183 15.9997 16 12.4181 16 7.99986ZM14.5 7.99986C14.5 4.41011 11.5899 1.5 8 1.5C4.41012 1.5 1.5 4.41011 1.5 7.99986C1.5 11.5896 4.41012 14.4997 8 14.4997C11.5899 14.4997 14.5 11.5896 14.5 7.99986Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14079_41292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.745255ae6583a365c2a2ab13398ade64.svg";
export { ForwardRef as ReactComponent };